import { Button, Image, Text } from "@chakra-ui/react";
import { React } from "react";

const ButtonIcon = ({ children, variant, icon, onclick, active, name }) => {
    return (
        <Button
            display="block"
            h="auto"
            w="auto"
            variant={variant}
            size="lg"
            borderRadius="md"
            borderWidth="1px"
            fontWeight="300"
            onClick={onclick}
            _hover={{ bg: "white" }}
            color="black"
            boxShadow="md"
            _focus={{
                boxShadow: "outline",
            }}
            aria-label="opción"
            textTransform="capitalize"
            align="left"
            textAlign="left"
            px={5}
            py={3}
            bg={active ? "brand.500" : "white"}
        >
            <Text fontSize={{ md: "md", base: "xs" }} mb={4}>
                {children}
            </Text>
            <Image src={icon} w="30px" alt="simple icon" />
        </Button>
    );
};

export default ButtonIcon;
